import { Divider, Stack, Typography } from "@mui/material"
import { FlatRichTextPreview } from "./flat-rich-text-preview"

export function RichTextComparison({ label, originalValue, tailoredValue, isNew = false }) {
    const hasOriginal = hasVisibleHtmlContent(originalValue)
    const hasNew = hasVisibleHtmlContent(tailoredValue)

    if (isNew) {
        return (
            <Stack spacing={0.75}>
                <Typography variant="subtitle2">{label}</Typography>
                <FlatRichTextPreview
                    hasContent={hasNew}
                    dataCy={`task-comparison-${label}-new`}
                    original={tailoredValue}
                    other={tailoredValue}
                    text={tailoredValue}
                    sourceOriginalValue={originalValue}
                    sourceTailoredValue={tailoredValue}
                    previewSide="new"
                />
            </Stack>
        )
    }

    return (
        <Stack spacing={0.75}>
            <Typography variant="subtitle2">{label}</Typography>
            <Stack direction="row" spacing={2} sx={{ alignItems: "stretch" }}>
                <Stack spacing={0.75} sx={{ flex: 1 }}>
                    <Typography variant="caption" color="text.secondary">
                        New
                    </Typography>
                    <FlatRichTextPreview
                        hasContent={hasNew}
                        dataCy={`task-comparison-${label}-new`}
                        original={originalValue}
                        other={originalValue}
                        text={tailoredValue}
                        sourceOriginalValue={originalValue}
                        sourceTailoredValue={tailoredValue}
                        previewSide="new"
                    />
                </Stack>
                <Divider orientation="vertical" flexItem />
                <Stack spacing={0.75} sx={{ flex: 1 }}>
                    <Typography variant="caption" color="text.secondary">
                        Original
                    </Typography>
                    <FlatRichTextPreview
                        hasContent={hasOriginal}
                        dataCy={`task-comparison-${label}-original`}
                        original={tailoredValue}
                        other={tailoredValue}
                        text={originalValue}
                        showRemoved
                        sourceOriginalValue={originalValue}
                        sourceTailoredValue={tailoredValue}
                        previewSide="original"
                    />
                </Stack>
            </Stack>
        </Stack>
    )
}

function hasVisibleHtmlContent(value) {
    return `${value ?? ""}`.replace(/<[^>]*>/g, "").trim().length > 0
}
